/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import {
  createPlugin,
  createRouteRef,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

export const rootCatalogKubernetesClusterRouteRef = createRouteRef({
  id: 'kubernetes-cluster',
});

export const kubernetesClusterPlugin = createPlugin({
  id: 'kubernetes-cluster',
  apis: [],
  routes: {
    entityContent: rootCatalogKubernetesClusterRouteRef,
  },
});

/**
 * Props of EntityKubernetesContent
 *
 * @public
 */
export type EntityKubernetesClusterContentProps = {};

/**
 * Props of EntityKubernetesContent
 *
 * @public
 */
export const EntityKubernetesClusterContent: (
  props: EntityKubernetesClusterContentProps,
) => JSX.Element = kubernetesClusterPlugin.provide(
  createRoutableExtension({
    name: 'EntityKubernetesClusterContent',
    component: () => import('./Router').then(m => m.Router),
    mountPoint: rootCatalogKubernetesClusterRouteRef,
  }),
);
